class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Added by MORYARTY - Open the mega-menu dropdown on hover (in addition
    // to the existing click-to-toggle on the <summary> element).
    //
    // Gated on `(hover: hover) and (pointer: fine)` so touch devices
    // (phones, tablets, hybrid laptops in touch mode) keep the click-only
    // behavior — otherwise the first tap on iOS Safari fires both
    // mouseenter AND click, producing a flash-open-then-close glitch.
    //
    // Close-on-leave uses a 150ms grace timer so the user can move the
    // cursor from the summary into the dropdown content without the menu
    // collapsing under them. Re-entering during the grace period cancels
    // the close (we re-check :hover inside the timeout).
    //
    // Click-toggle, keyboard nav (Enter/Space on summary), and focusout
    // close behavior from the parent class all still work — this is
    // additive only. See MOD-012 in MODIFICATIONS.md.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.openOnHover.bind(this));
      this.addEventListener('mouseleave', this.closeOnHoverLeave.bind(this));
    }
  }

  openOnHover() {
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeOnHoverLeave() {
    if (this._closeTimer) clearTimeout(this._closeTimer);
    this._closeTimer = setTimeout(() => {
      // Re-check :hover at fire-time so a quick re-entry cancels the close.
      if (!this.matches(':hover')) {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      }
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
